import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LayoutUtilsService, MessageType } from 'src/app/core/layout-utils.service';
import { Warenkorb } from '../../../store/models/warenkorb';
import { WarenkorbsService } from '../shared/warenkorbs.service';
import { MatDialog } from '@angular/material/dialog';
import { CheckoutComponent } from '../../checkout/checkout.component';
import { ViewEncapsulation } from '@angular/core';
import { CheckoutComponent_new } from '../../checkout_new/checkout_new.component';

@Component({
    selector: 'kkis-app-warenkorb-edit',
    templateUrl: './warenkorb-edit.component.html',
    styleUrls: ['./warenkorb-edit.component.scss'],
    encapsulation: ViewEncapsulation.None //https://stackoverflow.com/questions/46403698/css-values-not-applying-on-dynamically-injected-html-div-elements-in-angular-4
})
export class WarenkorbEditComponent implements OnInit {

    // OUTPUT
    @Output()
    numberWarenkorbItems: EventEmitter<number> = new EventEmitter<number>();

    menge: FormControl;
    orgMenge: number[] = [];

    notiz: FormControl;
    orgNotiz: string[] = [];

    WKNotiz: FormControl;
    orgWKNotiz: string = "";

    WKKDAuftragNr: FormControl;
    orgKDAuftragNr: string = "";

    // Warenkorb
    warenkorb: Warenkorb.IWarenkorbDto;

    gesamtBrutto: number;
    gesamtNetto: number;
    gesamtRabattBetrag: number;
    gesamtSteuerBetrag: number;

    infoMessage: string;
    warenkorbPositionen: Warenkorb.IWarenkorbPositionDto[];
    nWkPos: number;

    // (from local <<NOT>> FROM DATABASE)
    imgDummy: string = "assets/media/svg/files/no-image.svg";

    // Utils
    isLoading: boolean = false;
    isUpdate: boolean[] = [];
    isUpdateNotiz: boolean[] = [];
    isUpdateReceiptNotiz: boolean = false;
    isUpdateKDAuftragNr: boolean = false;

    constructor(
        private router: Router,
        private layoutUtilsService: LayoutUtilsService,
        private warenkorbsService: WarenkorbsService,
        private dialog: MatDialog
    ) { }

    ngOnInit(): void {
        this.menge = new FormControl(1, [Validators.required, Validators.min(0)])
        this.getData();
    }

    getData() {
        this.isLoading = true;

        this.warenkorbsService.getForCustomer().subscribe(res => {
            console.log('Warenkorb:');
            console.log(res);
            this.warenkorb = res;
            this.setData();
        });
    }

    setData() {
        if (this.warenkorb) {
            this.gesamtBrutto = this.warenkorb.gesamtBrutto;
            this.gesamtNetto = this.warenkorb.gesamtNetto;
            this.gesamtRabattBetrag = this.warenkorb.gesamtRabattBetrag;
            this.gesamtSteuerBetrag = this.warenkorb.gesamtSteuerBetrag;

            this.orgWKNotiz = this.warenkorb.notiz;
            this.orgKDAuftragNr = this.warenkorb.kdAuftragNr;

            if (this.warenkorb.warenkorbPositionen.length == 0) {
                this.infoMessage = "Ihr Einkaufswagen ist leer."

                this.warenkorbPositionen = [];
                this.nWkPos = 0;
            } else {
                this.warenkorbPositionen = this.warenkorb.warenkorbPositionen;

                console.log("wkPos => ", this.warenkorbPositionen);

                let i = 0;

                this.warenkorbPositionen.forEach(x => {
                    this.orgMenge[i] = x.menge;
                    this.orgNotiz[i] = x.notiz;

                    i += 1;
                });

                this.nWkPos = this.warenkorbPositionen.length;
            }

            this.numberWarenkorbItems.emit(this.nWkPos);

            this.isLoading = false;
        } else {
            this.warenkorbPositionen = [];
            this.isLoading = false;
        }
    }

    onChangeMenge(event, i?: number) {
        var x = this.warenkorbPositionen[i].menge;
        this.isUpdate[i] = true;
    }

    onChangeNotiz(event, i?: number) {
        console.log('in change Notiz');
        var x = this.warenkorbPositionen[i].notiz;
        this.isUpdateNotiz[i] = true;
    }

    onChangeReceiptNotiz(event) {
        console.log('in change Receipt Notiz');
        var x = this.warenkorb.notiz;
        this.isUpdateReceiptNotiz = true;
    }

    onChangeKDAuftragNr(event) {
        console.log('in change KDAuftragNr');
        var x = this.warenkorb.kdAuftragNr;
        this.isUpdateKDAuftragNr = true;
    }

    getErrorMessageMenge() {
        if (this.menge.hasError('required')) {
            return 'Menge ist erforderlich.'
        }

        if (this.menge.hasError('min')) {
            return 'Der Wert muss > sein.'
        }

        if (this.menge.hasError('max')) {
            // return 'Der Wert muss < ' + (this.bestand + 1) + ' sein.'
        }
    }

    onUpdate(warenkorbPosition: Warenkorb.IWarenkorbPositionDto, i?: number) {
        let newPosition = {} as Warenkorb.IAddPositionDto;

        newPosition.artikelKennung = warenkorbPosition.artikelKennung;
        newPosition.menge = warenkorbPosition.menge - this.orgMenge[i];
        newPosition.isMatrixArtikel = (warenkorbPosition.matrixIntern != null && warenkorbPosition.matrixIntern != 0);
        newPosition.notiz = warenkorbPosition.notiz;

        this.warenkorbsService.addPosition(newPosition).subscribe(res => {
            this.getData();
        });

        this.isUpdate[i] = false;
        this.isUpdateNotiz[i] = false;
    }

    onUpdateWK(warenkorb: Warenkorb.IUpdateWarenkorbDto) {

        this.warenkorbsService.updateWarenkorb(warenkorb.id, warenkorb).subscribe(res => {
            this.getData();
        });

        this.isUpdateReceiptNotiz = false;
        this.isUpdateKDAuftragNr = false;
    }
    
    onCancelUpdate(i) {
        this.warenkorbPositionen[i].menge = this.orgMenge[i];
        this.warenkorbPositionen[i].notiz = this.orgNotiz[i];
        this.isUpdate[i] = false;
        this.isUpdateNotiz[i] = false;
    }

    onCancelUpdateWK() {
        this.warenkorb.notiz = this.orgWKNotiz;

        this.isUpdateReceiptNotiz = false;
    }

    onCancelUpdateKDAuftragNr() {
        this.warenkorb.kdAuftragNr = this.orgKDAuftragNr;

        this.isUpdateKDAuftragNr = false;
    }

    onDelete(warenkorbPosition: Warenkorb.IWarenkorbPositionDto) {
        const _title: string = "Warenkorb-Position entfernen";
        const _description: string = "Soll die aktuelle Warenkorb-Position wirklich entfernt werden?";
        const _waitDesciption: string = "Einen Augenblick Geduld bitte...";
        const _deleteMessage = "Die Warenkorb-Position wurde entfernt.";

        this.layoutUtilsService.deleteElement(_title, _description, _waitDesciption).then(res => {
            if (res.dismiss) {
                return;
            }

            this.warenkorbsService.deletePosition(warenkorbPosition.id).subscribe(res => {
                this.warenkorb = res;
                this.setData();

                this.layoutUtilsService.showActionNotification(_deleteMessage, MessageType.Delete);
            });
        });
    }

    onDeleteWarenkorb(warenkorb: Warenkorb.IWarenkorbDto) {
        const _title: string = "Warenkorb entfernen";
        const _description: string = "Soll der Warenkorb wirklich entfernt werden?";
        const _waitDesciption: string = "Einen Augenblick Geduld bitte...";
        const _deleteMessage = "Der Warenkorb wurde entfernt.";

        this.layoutUtilsService.deleteElement(_title, _description, _waitDesciption).then(res => {
            if (res.dismiss) {
                return;
            }

            this.warenkorbsService.deleteWarenkorb(warenkorb.id).subscribe(res => {

                if (res == true) {

                    this.goBack();
                    this.numberWarenkorbItems.emit(0);
                }

                this.layoutUtilsService.showActionNotification(_deleteMessage, MessageType.Delete);
            });
        });
    }

    goBack() {
        this.router.navigate(['/articles'], {
            queryParams: {
                showWarenkorb: false,
                showAdvertise: false
            }
        });
    }

    checkout(inputrequesttype:number) {
        //const dialogRef = this.dialog.open(CheckoutComponent, { //alter Dialog
        const dialogRef = this.dialog.open(CheckoutComponent_new, {
            width: '50%',
            disableClose: true,
            autoFocus: true,
            data: {
                requesttype: inputrequesttype
              }
        });

        dialogRef.afterClosed().subscribe((res: any) => {
            //if(res)

            //Eric
            if (res == 'do_order') {
                this.makeOrder();
            } else if (res == 'do_request') {
                this.makeRequest();
            }

            //RELOAD
            this.getData();
        });

        //this.router.navigate(['/checkout']);
    }

    makeOrder() {
        this.warenkorbsService.makeOrder(this.warenkorb).subscribe({
            next: data => {
                console.log(data);

                if (data == true) {
                    console.log('Bestellung erzeugt');
                    //this.router.navigate(['/articles']); //zurück zur Hauptansicht
                    this.goBack();
                    this.numberWarenkorbItems.emit(0);
                    alert('Ihre Bestellung wurde angenommen.');
                } else if (data == false) {
                    console.log('Fehler beim Erzeugen der Bestellung');
                }

            },
            error: error => {
                console.error(error);
            }
        });
    }

    makeRequest() {
        this.warenkorbsService.makeRequest(this.warenkorb).subscribe({
            next: data => {
                console.log(data);

                if (data == true) {
                    console.log('Preisanfrage erzeugt');
                    //this.router.navigate(['/articles']); //zurück zur Hauptansicht
                    this.goBack();
                    this.numberWarenkorbItems.emit(0);
                    alert('Ihre Preisanfrage wurde gesendet.');
                } else if (data == false) {
                    console.log('Fehler beim Erzeugen der Preisanfrage');
                }

            },
            error: error => {
                console.error(error);
            }
        });
    }

    onShowStaffel(event, i?: number) {
        console.log('in onShowStaffel');

        //var div_staffelpreise = $(event.originalTarget).parents('.artikelcardList').find('.view_staffelpreise');
        var div_staffelpreise = $(event.currentTarget).parents('.artikelcardList').find('.view_staffelpreise');
        if ($(div_staffelpreise).length > 0) {

            $(div_staffelpreise).toggleClass('visible');

            if ($(div_staffelpreise).hasClass('visible')) {

                var kennung_artikel = this.warenkorbPositionen[i].artikelKennung;

                this.warenkorbsService.getStaffelpreis(kennung_artikel).subscribe(res => {
                    var json_staffelpreise = JSON.parse(JSON.stringify(res));


                    if (json_staffelpreise.length > 0) {
                        var res_html = '<div>';

                        res_html += "<div class='cnt_staffelpreis_header'>";
                        res_html += "<div class='col_staffelpreis_h range'>Menge</div>";
                        res_html += "<div class='col_staffelpreis_h netto'>Preis netto</div>";
                        res_html += "<div class='col_staffelpreis_h brutto'>Preis brutto</div>";
                        res_html += "</div>";

                        for (let i = 0; i < json_staffelpreise.length; i++) {

                            res_html += "<div class='cnt_staffelpreis'>";
                            res_html += "<div class='col_staffelpreis range'>" + json_staffelpreise[i].Von + "-" + json_staffelpreise[i].Bis + "</div>";
                            res_html += "<div class='col_staffelpreis netto'>" + parseFloat(json_staffelpreise[i].Netto).toFixed(2) + " €</div>";
                            res_html += "<div class='col_staffelpreis brutto'>" + parseFloat(json_staffelpreise[i].Brutto).toFixed(2) + " €</div>";
                            res_html += "</div>";

                        }

                        res_html += '</div>';

                        $(div_staffelpreise).html(res_html);

                    }

                });


            }

        }


    }
}
